import { Mail } from "lucide-react";

export default function Navbar({ t, lang, setLang, onNav }) {
  const links = [
    { id: "how", label: t.nav.how },
    { id: "players", label: t.nav.players },
    { id: "scouts", label: t.nav.scouts },
    { id: "showcase", label: t.nav.showcase },
  ];

  return (
    <header
      data-testid="main-navbar"
      className="fixed inset-x-0 top-4 z-50 flex justify-center px-4"
    >
      <div className="flex w-full max-w-5xl items-center justify-between gap-4 rounded-full border border-white/10 bg-[#06080C]/80 px-5 py-3 shadow-[0_8px_32px_rgba(0,0,0,0.5)] backdrop-blur-xl">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0)}
          className="flex items-center gap-2"
        >
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-[#00F562] shadow-[0_0_18px_rgba(0,245,98,0.6)]">
            <span className="font-display text-[11px] font-black leading-none tracking-tight text-[#06080C]">
              TH
            </span>
          </span>
          <span className="font-display text-sm font-extrabold uppercase tracking-widest">
            Talent<span className="text-[#00F562]">Hub</span>
          </span>
        </button>

        <nav className="hidden items-center gap-6 lg:flex">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => onNav(l.id)}
              className="text-xs font-medium uppercase tracking-[0.18em] text-slate-400 transition-colors duration-300 hover:text-[#00F562]"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div
            data-testid="language-toggle"
            className="flex items-center rounded-full border border-white/10 p-0.5"
          >
            {["it", "en", "es", "de"].map((l) => (
              <button
                key={l}
                data-testid={`lang-${l}-button`}
                onClick={() => setLang(l)}
                className={`rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest transition-colors duration-300 ${
                  lang === l
                    ? "bg-[#00F562] text-[#06080C]"
                    : "text-slate-400 hover:text-white"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <button
            data-testid="nav-contact-button"
            type="button"
            onClick={() => onNav("contact")}
            className="hidden items-center gap-2 rounded-full border border-[#00F562]/40 px-4 py-2 text-[11px] font-bold uppercase tracking-widest text-[#00F562] transition-all duration-300 hover:bg-[#00F562] hover:text-[#06080C] hover:shadow-[0_0_24px_rgba(0,245,98,0.5)] sm:flex"
          >
            <Mail size={13} />
            {t.nav.contact}
          </button>
        </div>
      </div>
    </header>
  );
}
